import { render, staticRenderFns } from "./PersonSettings.vue?vue&type=template&id=445aacfc"
import script from "./PersonSettings.vue?vue&type=script&lang=js"
export * from "./PersonSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports